export var valuesResultCalculationType = ["AddPoints", "AddPointsAndConsiderTime"];
/*

*/ 
//# sourceMappingURL=ResultCalculationType.js.map